<template lang="pug">
  .recaptcha-notice This site is protected by reCAPTCHA and the Google&nbsp;
    a.linked(href="https://policies.google.com/privacy" target="_blank") Privacy Policy&nbsp;
    | and&nbsp;
    a.linked(href="https://policies.google.com/terms" target="_blank") Terms of Service&nbsp;
    | apply.
</template>

<script>
export default {
  name: 'RecaptchaNotice'
}
</script>

<style lang="scss" scoped>
.recaptcha-notice {
  font-size: 12px;
  color: rgba(black, 0.6);
  margin: 12px 0 16px 0;
  word-break: break-word;
  line-height: 150%;

  &.white {
    color: rgba(white, 0.6);
    .linked {
      color:  $--color-primary-light;
    }
  }
}
</style>
